import { render, staticRenderFns } from "./ModalAddCross.vue?vue&type=template&id=7b0cd70c&"
import script from "./ModalAddCross.vue?vue&type=script&lang=js&"
export * from "./ModalAddCross.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports